import React, { useCallback, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import OpportunitiesListHeader from './components/list/OpportunitiesListHeader';
import OpportunitiesListFilters from './components/list/OpportunitiesListFilters';
import { FILTER } from './components/helpers/opportunitiesListHelper';
import OpportunitiesListContainer from './components/list/OpportunitiesListContainer';
import translate from '../../commonComponents/translate';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import LoggedUserContext from '../../contextProviders/LoggedUserContext';
import ConfigsContext from '../../contextProviders/ConfigsContext';
import User from '../../../../../domain/models/user';
import { BUYER_TYPE } from '../../services/utilityFunctions';

function OpportunitiesList(props) {
  const { t } = props;
  const { loggedUser } = useContext(LoggedUserContext);
  const { tenant } = useContext(ConfigsContext);

  const initialState = useMemo(
    () => ({
      search: null,
      startDate: null,
      endDate: null,
      buyerType:
        loggedUser?.type === User.TYPE.COLLABORATOR
          ? BUYER_TYPE.SELLER
          : BUYER_TYPE.OWNER,
      owner: undefined,
    }),
    [loggedUser?.type],
  );

  const [filters, setFilters] = useState(initialState);

  /**
   * Handle the filters change
   * @param {TYPES} field State field to update
   * @param {string} value1 New value
   * @param {string|undefined} value2 New value, used mainly to set endDate
   */
  const handleFiltersChange = useCallback(
    field => (value1, value2) => {
      switch (field) {
        case FILTER.DATE:
          setFilters(prevFilters => ({
            ...prevFilters,
            startDate: value1,
            endDate: value2,
          }));
          break;
        case FILTER.BUYER_TYPE:
          setFilters(prevFilters => ({
            ...prevFilters,
            [field]: value1,
            owner: value1 === BUYER_TYPE.OWNER ? undefined : prevFilters?.owner,
          }));
          break;
        case FILTER.SEARCH:
        default:
          setFilters(prevFilters => ({ ...prevFilters, [field]: value1 }));
          break;
      }
    },
    [setFilters],
  );

  return (
    <Title title={t('shop.my_opportunities')}>
      <ContentContainer>
        <SubHeader title={t('shop.my_opportunities')} />
        <div className="m-portlet">
          <OpportunitiesListHeader loggedUser={loggedUser} tenant={tenant} />
          <OpportunitiesListFilters
            onFilterChange={handleFiltersChange}
            filters={filters}
            loggedUser={loggedUser}
          />
          <OpportunitiesListContainer filters={filters} />
        </div>
      </ContentContainer>
    </Title>
  );
}

OpportunitiesList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(OpportunitiesList);
